"use client"
import Footer from '../components/Footer';
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import EarthingBanner from '../components/EarthingBanner';
import { ProductProvider } from '../components/Productcontext';
import banner1 from '../images/whypage/why_banner.jpg';
import banner_360 from '../images/whypage/why_banner_360.jpg';
import banner_tab from '../images/whypage/why_banner_tab.jpg';
import banner1_2x from '../images/whypage/why_banner@2x.jpg';

import WhypageContent from '../components/WhypageContent';
import GifLoader from '../components/GifLoader';

export default function WhyPage() {
    return (
        <div>
            {/* <PreHeader/>
            <Header/>
            <Menu/> */}
            <EarthingBanner page="Why" banalt="Why Choose Ashlok Safe Earthing Electrode Limited for reliable earthing and lightning protection solutions?" bannertext="" ban1x={banner1} ban2x={banner1_2x} ban360={banner_360} bantab={banner_tab}/>
            <WhypageContent/>
            <GifLoader imgalt="Earth and building infrastructure diagram showcasing earthing solutions by Ashlok Safe Earthing Electrode Limited"  grassimgalt="Ashlok BackFill Compounds providing eco-friendly earthing solutions across industries"/>
            <ProductProvider>
                <Footer/>
            </ProductProvider>
        </div>
    )

}